import { Card, Text, Button, Flex } from "@amzn/storm-ui";
import type { TooltipRenderProps } from "react-joyride";

export const StormTouringTooltip = ({
    continuous,
    index,
    step,
    backProps,
    closeProps,
    primaryProps,
    skipProps,
    tooltipProps,
    size,
}: TooltipRenderProps): JSX.Element => (
    <Card {...tooltipProps} style={{ maxWidth: 300 }}>
        <Flex direction="column" rowGap="small">
            <Text>{step.content}</Text>
            <Flex direction="row" columnGap="small" justifyContent="flex-end">
                {index > 0 && (
                    <Button {...backProps} variant="default">
                        Back
                    </Button>
                )}
                {continuous && (
                    <Button {...primaryProps} variant="primary">
                        {index === (size || 0) - 1 ? "End" : "Next"}
                    </Button>
                )}
                {!continuous && (
                    <Button {...closeProps} variant="primary">
                        Close
                    </Button>
                )}
                {index !== (size || 0) - 1 && (
                    <Button {...skipProps} variant="transparent">
                        Skip
                    </Button>
                )}
            </Flex>
        </Flex>
    </Card>
);
